var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccGrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acc-gr-icon",
    transform: "translate(-340 -1089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    transform: "translate(340 1089)",
    fill: "none",
    stroke: "#abfdae",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 28,
    rx: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 13,
    height: 26,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    transform: "translate(351 1103) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,0,7,5H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 2.615689992904663 L 2.880982875823975 3.5 L 4.119016647338867 3.5 L 3.5 2.615689992904663 M 3.5 0 L 7 5 L 0 5 L 3.5 0 Z",
    stroke: "none",
    fill: "#abfdae"
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_4",
    "data-name": "L\\xEDnea 4",
    x2: 14,
    transform: "translate(340.5 1104)",
    fill: "none",
    stroke: "#abfdae",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccGrIcon);
export default __webpack_public_path__ + "static/media/acc-gr-icon.3cb5af7f7c86723f9b1950d5c6c300da.svg";
export { ForwardRef as ReactComponent };